import {useContext, useState, useEffect, useMemo} from "react";
import { UserContext } from '../Context/UserContext'
import SubPassComp from "./SubPassComp";
import CheckoutForm from "./CheckoutForm";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import SignupLoginButtons from "./SignupLoginButtons";
import "../styles/checkout.css"
import BatterIconLogo from "./BatterIconLogo";
import FeatureComparison from "./FeatureComparison";

function Checkout() {
    const {state, isActiveSub} = useContext(UserContext);
    const [publishableKey, setPublishableKey] = useState(null)
    const [subTypeFromChild, setSubTypeFromChild] = useState('')

    useEffect(() => {
        const fetchPublishableKey = async () => {
            const response = await fetch('/credentials')
            const data = await response.json()
            setPublishableKey(data.stripe_publishable_key)
        }
        fetchPublishableKey();
    }, [])

    const stripePromise = useMemo(() => {
        if (publishableKey) {
            return loadStripe(publishableKey)
        }
    }, [publishableKey])
    //console.log('stripePromise', stripePromise)
    //console.log('publishablekey', publishableKey)

    const oneTimeOptions = {
        mode: 'payment',
        currency: 'usd',
        amount: 50, //STRIPE PAYMENT ELEMENT WILL ERROR OUT IF THIS AMOUNT IS NOT 50, TRIED CHANGING TO 30 AND IT DIDN'T WORK
        //the price will still be correct based on whats on the checkoutform so this 50 amount wont impact the price.
    }

    const monthlyOptions = {
        mode: 'subscription',
        currency: 'usd',
        amount: 2000,
    }

    function handleDataChange(data) {
        setSubTypeFromChild(data)
    }

    return (
        <div>
            {/* <h2>Ability to purchase premium subscriptions will return for the 2026 season.</h2> */}
            {isActiveSub && 
                (<div className="alreadyPremium">
                    <h2>You're already using an active subscription.</h2>
                    <h3>Having issues? Email us at contactbattersbox@gmail.com.</h3>
                </div>
                )
            }
            {state?.loggedIn && !isActiveSub && (
                <div>
                    <div className="checkoutContainer">
                        <FeatureComparison />
                        <SubPassComp />
                        {stripePromise && (
                        <Elements stripe={stripePromise} options={subTypeFromChild === 'Monthly Pass' ? monthlyOptions : oneTimeOptions}>
                            <CheckoutForm onDataChange={handleDataChange} selectedSubType={subTypeFromChild} />
                        </Elements>
                        )}
                    </div>
                </div>
                )
            }
            {!state?.loggedIn && (
                <div className="notSignedInContainer">
                    <div className="notSignedInTopContainer">
                        {/* WILL NEED TO MOVE LOGO ON CHECKOUT CSS PAGE WHEN I REMOVE THE SALE HEADER */}
                        <BatterIconLogo logoID={"loggedOutCheckoutBattersIconLogo"} />
                        {/*<h3 className="saleHeader">Save $30 on a season pass now through March 29th!</h3>*/}
                    </div>
                    <div className="checkoutNotSignedIn">
                        {/* <h3 style={{textAlign: "center", color: "black", marginTop: "2rem"}}>Premium is FREE for the World Series. Just sign up or login to gain access!</h3> */}
                        <h1>Please Sign Up or Login</h1>
                        <SignupLoginButtons className="checkoutSignUpLoginButtons"/>
                        <div className="checkoutNotSignedInSubPassBox">
                            <FeatureComparison />
                            <SubPassComp />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Checkout